/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AfterOrderBannerCreatedBy } from './after-order-banner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { AfterOrderBannerImage } from './after-order-banner-image';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'type'?: MessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'urlPattern'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    'web'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    'android'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    'ios'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'closeAction'?: MessageCloseActionEnum;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'whiteLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'privacy'?: MessagePrivacyEnum;
    /**
     * 
     * @type {AfterOrderBannerImage}
     * @memberof Message
     */
    'icon'?: AfterOrderBannerImage;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    'androidWebApp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Message
     */
    'iosWebApp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'searchMode'?: MessageSearchModeEnum;
    /**
     * 
     * @type {AfterOrderBannerCreatedBy}
     * @memberof Message
     */
    'created_by'?: AfterOrderBannerCreatedBy;
    /**
     * 
     * @type {AfterOrderBannerCreatedBy}
     * @memberof Message
     */
    'updated_by'?: AfterOrderBannerCreatedBy;
}

export const MessageTypeEnum = {
    Once: 'once',
    Always: 'always'
} as const;

export type MessageTypeEnum = typeof MessageTypeEnum[keyof typeof MessageTypeEnum];
export const MessageCloseActionEnum = {
    None: 'none',
    Once: 'once',
    Always: 'always'
} as const;

export type MessageCloseActionEnum = typeof MessageCloseActionEnum[keyof typeof MessageCloseActionEnum];
export const MessagePrivacyEnum = {
    All: 'all',
    Unauthorized: 'unauthorized',
    Normal: 'normal',
    Organizational: 'organizational'
} as const;

export type MessagePrivacyEnum = typeof MessagePrivacyEnum[keyof typeof MessagePrivacyEnum];
export const MessageSearchModeEnum = {
    International: 'international',
    Domestic: 'domestic',
    Both: 'both'
} as const;

export type MessageSearchModeEnum = typeof MessageSearchModeEnum[keyof typeof MessageSearchModeEnum];


